import { BadgePanel, HonestyPopover, type PanelRow } from './Popover'
import { CHIP_BASE } from './chrome'
import { t } from '@/lib/ui'

// design badge (DESIGN-BRIEF §4): amber chip, outline. Author-designed choice,
// not law. Clicking reveals the rationale and the borrowed pattern (Estonia
// proactive, OpenFisca rules-as-code, NAV, EESSI) where the spec names one
// (SIM-015).

interface DesignBadgeProps {
  /** Why this design choice. */
  rationale?: string
  /** Borrowed pattern, e.g. "Estonia offer-confirm". */
  pattern?: string
  /** e.g. "prc-002" — deep-links to /spec/:id */
  specId?: string
  label?: string
}

export function DesignBadge({ rationale, pattern, specId, label }: DesignBadgeProps) {
  const rows: PanelRow[] = []
  if (pattern) rows.push({ label: t('honesty.popover.patternLabel'), value: pattern })

  // Accessible name must CONTAIN the visible label text (WCAG 2.5.3 Label in Name),
  // so lead the aria-label with the visible chip word before the full FI name.
  const visibleLabel = label ?? t('honesty.design.label')

  return (
    <HonestyPopover
      triggerAriaLabel={`${visibleLabel} – ${t('honesty.design.name')}`}
      triggerClassName={`${CHIP_BASE} border border-design text-design hover:bg-design/10`}
      triggerLabel={visibleLabel}
    >
      <BadgePanel
        name={t('honesty.design.name')}
        hint={rationale ?? t('honesty.design.hint')}
        rows={rows}
        specId={specId}
      />
    </HonestyPopover>
  )
}
